import StyledWrapper from "./style";
import { TActionsProps } from "./TableActions.type";
import Tooltip from "@mui/material/Tooltip";
import LockResetIcon from '@mui/icons-material/LockReset';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import SystemSecurityUpdateGoodIcon from '@mui/icons-material/SystemSecurityUpdateGood';
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
import CommentIcon from '@mui/icons-material/Comment';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
/**
 * paginationItems
 * @param {String} type String to choose which button icon to display OPTIONS: 'Edit' | 'View' | 'Delete' | 'Add' | 'Download' | 'Upload'
 * @param {Function} onClick onClick function for button
 */

export default function PrimaryButton({ type, onClick, title, color }: TActionsProps) {
  return (
    <>
      {type === "Add" && (
        <Tooltip title={title || "Agregar"}>
          <StyledWrapper.ActionContainer type="Add" onClick={onClick}>
            <svg
              className=""
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="fill-current"
                d="M10.15 6.3C11.1711 6.3 12.1503 6.70562 12.8724 7.42764C13.5944 8.14965 14 9.12892 14 10.15C14 11.1711 13.5944 12.1503 12.8724 12.8724C12.1503 13.5944 11.1711 14 10.15 14C9.12892 14 8.14965 13.5944 7.42764 12.8724C6.70562 12.1503 6.3 11.1711 6.3 10.15C6.3 9.12892 6.70562 8.14965 7.42764 7.42764C8.14965 6.70562 9.12892 6.3 10.15 6.3ZM10.325 0C10.9284 0 11.507 0.239687 11.9337 0.666332C12.3603 1.09298 12.6 1.67163 12.6 2.275L12.6007 6.3161C12.2735 6.10607 11.9206 5.93903 11.5507 5.8191L11.55 3.85H1.05V10.325C1.05 11.0012 1.5988 11.55 2.275 11.55H5.8198C5.9402 11.9238 6.1082 12.2766 6.3161 12.6007L2.275 12.6C1.67163 12.6 1.09298 12.3603 0.666332 11.9337C0.239687 11.507 0 10.9284 0 10.325V2.275C0 1.67163 0.239687 1.09298 0.666332 0.666332C1.09298 0.239687 1.67163 0 2.275 0H10.325ZM10.15 7.7L10.087 7.7056C10.0171 7.71838 9.95268 7.75215 9.90241 7.80241C9.85215 7.85268 9.81838 7.91707 9.8056 7.987L9.8 8.05V9.8H8.05L7.987 9.8056C7.91707 9.81838 7.85268 9.85215 7.80241 9.90241C7.75215 9.95268 7.71838 10.0171 7.7056 10.087L7.7 10.15L7.7056 10.213C7.71838 10.2829 7.75215 10.3473 7.80241 10.3976C7.85268 10.4479 7.91707 10.4816 7.987 10.4944L8.05 10.5H9.8V12.25L9.8056 12.313C9.81838 12.3829 9.85215 12.4473 9.90241 12.4976C9.95268 12.5479 10.0171 12.5816 10.087 12.5944L10.15 12.6L10.213 12.5944C10.2829 12.5816 10.3473 12.5479 10.3976 12.4976C10.4479 12.4473 10.4816 12.3829 10.4944 12.313L10.5 12.25V10.5H12.25L12.313 10.4944C12.3829 10.4816 12.4473 10.4479 12.4976 10.3976C12.5479 10.3473 12.5816 10.2829 12.5944 10.213L12.6 10.15L12.5944 10.087C12.5816 10.0171 12.5479 9.95268 12.4976 9.90241C12.4473 9.85215 12.3829 9.81838 12.313 9.8056L12.25 9.8H10.5V8.05L10.4944 7.987C10.4816 7.91707 10.4479 7.85268 10.3976 7.80241C10.3473 7.75215 10.2829 7.71838 10.213 7.7056L10.15 7.7ZM10.325 1.05H2.275C1.95011 1.05 1.63853 1.17906 1.40879 1.40879C1.17906 1.63853 1.05 1.95011 1.05 2.275V2.8H11.55V2.275C11.55 1.95011 11.4209 1.63853 11.1912 1.40879C10.9615 1.17906 10.6499 1.05 10.325 1.05Z"
                fill="#A6A6A6"
              />
            </svg>
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "Edit" && (
        <Tooltip title={title || "Editar"}>
          <StyledWrapper.ActionContainer type="Edit" onClick={onClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                className="fill-current"
                d="M3.00586 10.922L6.32195 10.9108L13.5598 3.74206C13.8438 3.45801 14.0001 3.08079 14.0001 2.67953C14.0001 2.27826 13.8438 1.90104 13.5598 1.617L12.368 0.425219C11.7999 -0.142867 10.8088 -0.139861 10.2452 0.422964L3.00586 7.59316V10.922ZM11.3055 1.48775L12.4995 2.67727L11.2995 3.86604L10.1077 2.67502L11.3055 1.48775ZM4.50873 8.21986L9.03989 3.73154L10.2317 4.92331L5.70126 9.41014L4.50873 9.41389V8.21986Z"
                fill="#A6A6A6"
              />
              <path
                className="fill-current"
                d="M1.50287 13.9184H12.023C12.8518 13.9184 13.5258 13.2444 13.5258 12.4156V5.9021L12.023 7.40498V12.4156H3.87591C3.85637 12.4156 3.83608 12.4231 3.81654 12.4231C3.79175 12.4231 3.76695 12.4163 3.7414 12.4156H1.50287V1.89545H6.64795L8.15082 0.392578H1.50287C0.674038 0.392578 0 1.06662 0 1.89545V12.4156C0 13.2444 0.674038 13.9184 1.50287 13.9184Z"
                fill="#A6A6A6"
              />
            </svg>
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "Delete" && (
        <Tooltip title={title || "Borrar"}>
          <StyledWrapper.ActionContainer type="Delete" onClick={onClick}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="stroke-current"
                d="M1 3.8H15M6.6 7.3V10.8M9.4 7.3V10.8M2.4 3.8H13.6L12.494 13.754C12.4561 14.0966 12.2931 14.4131 12.0364 14.643C11.7796 14.8729 11.4471 15 11.1024 15H4.8976C4.55295 15 4.22039 14.8729 3.96362 14.643C3.70685 14.4131 3.54391 14.0966 3.506 13.754L2.4 3.8ZM4.7415 1.8029C4.85473 1.56278 5.03389 1.3598 5.2581 1.21764C5.48231 1.07548 5.74232 0.999997 6.0078 1H9.9922C10.2578 0.999864 10.518 1.07528 10.7423 1.21745C10.9666 1.35962 11.1459 1.56267 11.2592 1.8029L12.2 3.8H3.8L4.7415 1.8029Z"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "View" && (
        <Tooltip title={title || "Ver"}>
          <StyledWrapper.ActionContainer type="View" onClick={onClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="13"
              viewBox="0 0 18 13"
              fill="none"
            >
              <path
                className="stroke-current"
                d="M9.00376 0.900071L9.00377 0.899788L8.99624 0.900071C7.23827 0.966179 5.5382 1.54596 4.10615 2.56776C2.67411 3.58955 1.57285 5.00857 0.938501 6.64944L0.938479 6.64943L0.937731 6.65149C0.887423 6.79065 0.887423 6.94302 0.937731 7.08217L0.937709 7.08218L0.938501 7.08423C1.57285 8.72509 2.67411 10.1441 4.10615 11.1659C5.5382 12.1877 7.23827 12.7675 8.99624 12.8336L8.99623 12.8339L9.00376 12.8336C10.7617 12.7675 12.4618 12.1877 13.8938 11.1659C15.3259 10.1441 16.4271 8.72509 17.0615 7.08424L17.0623 7.08217C17.1126 6.94302 17.1126 6.79065 17.0623 6.65149L16.9682 6.68549L17.0615 6.64944C16.4271 5.00857 15.3259 3.58955 13.8938 2.56776C12.4618 1.54596 10.7617 0.966179 9.00376 0.900071ZM9 11.567C6.22934 11.567 3.29244 9.51714 2.21166 6.86683C3.29244 4.21653 6.22934 2.1667 9 2.1667C11.7707 2.1667 14.7076 4.21653 15.7883 6.86683C14.7076 9.51713 11.7707 11.567 9 11.567Z"
                fill="#A6A6A6"
                stroke="#A6A6A6"
                strokeWidth="0.2"
              />
              <path
                className="stroke-current"
                d="M8.9999 3.56602C8.3472 3.56602 7.70916 3.75956 7.16646 4.12218C6.62377 4.4848 6.20079 5.0002 5.95101 5.60322C5.70123 6.20623 5.63588 6.86977 5.76322 7.50992C5.89055 8.15008 6.20485 8.7381 6.66638 9.19962C7.12791 9.66115 7.71593 9.97545 8.35608 10.1028C8.99624 10.2301 9.65977 10.1648 10.2628 9.91499C10.8658 9.66522 11.3812 9.24224 11.7438 8.69954C12.1064 8.15684 12.3 7.5188 12.3 6.86611C12.3 5.99087 11.9523 5.15148 11.3334 4.53259C10.7145 3.9137 9.87514 3.56602 8.9999 3.56602ZM8.9999 8.8995C8.59773 8.8995 8.20459 8.78024 7.8702 8.55681C7.53581 8.33338 7.27519 8.01581 7.12129 7.64425C6.96738 7.2727 6.92711 6.86385 7.00557 6.46941C7.08403 6.07497 7.27769 5.71266 7.56207 5.42828C7.84645 5.1439 8.20876 4.95024 8.6032 4.87178C8.99764 4.79332 9.40649 4.83359 9.77804 4.9875C10.1496 5.1414 10.4672 5.40202 10.6906 5.73641C10.914 6.0708 11.0333 6.46394 11.0333 6.86611C11.0333 7.4054 10.8191 7.9226 10.4377 8.30393C10.0564 8.68527 9.53919 8.8995 8.9999 8.8995Z"
                fill="#A6A6A6"
                stroke="#A6A6A6"
                strokeWidth="0.2"
              />
            </svg>
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "Download" && (
        <Tooltip title={title || "Descargar"}>
          <StyledWrapper.ActionContainer type="Download" onClick={onClick}>
            <svg
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 11.1111L1.4347 12.9058C1.51041 13.2183 1.68518 13.4957 1.93123 13.694C2.17729 13.8922 2.48051 14 2.7927 14H13.2073C13.5195 14 13.8227 13.8922 14.0688 13.694C14.3148 13.4957 14.4896 13.2183 14.5653 12.9058L15 11.1111M8 9.66667V1V9.66667ZM8 9.66667L5.2 6.77778L8 9.66667ZM8 9.66667L10.8 6.77778L8 9.66667Z"
                stroke="#B0B0B0"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}
      {type === "Upload" && (
        <Tooltip title="Subir">
          <StyledWrapper.ActionContainer type="Upload" onClick={onClick}>
            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.84611 3.3001L5.77778 2.39037V10.501C5.77778 10.6866 5.85387 10.8646 5.98931 10.9958C6.12475 11.1271 6.30845 11.2008 6.5 11.2008C6.69155 11.2008 6.87525 11.1271 7.01069 10.9958C7.14613 10.8646 7.22222 10.6866 7.22222 10.501V2.39037L8.15389 3.3001C8.22103 3.36569 8.30091 3.41775 8.38892 3.45328C8.47693 3.48881 8.57132 3.5071 8.66667 3.5071C8.76201 3.5071 8.85641 3.48881 8.94442 3.45328C9.03243 3.41775 9.1123 3.36569 9.17944 3.3001C9.24714 3.23505 9.30087 3.15765 9.33753 3.07237C9.3742 2.9871 9.39308 2.89563 9.39308 2.80325C9.39308 2.71086 9.3742 2.6194 9.33753 2.53412C9.30087 2.44884 9.24714 2.37145 9.17944 2.30639L7.01278 0.206999C6.94564 0.141408 6.86576 0.089347 6.77775 0.0538192C6.68974 0.0182915 6.59534 0 6.5 0C6.40466 0 6.31026 0.0182915 6.22225 0.0538192C6.13424 0.089347 6.05436 0.141408 5.98722 0.206999L3.82056 2.30639C3.68456 2.43816 3.60816 2.61689 3.60816 2.80325C3.60816 2.9896 3.68456 3.16833 3.82056 3.3001C3.95655 3.43188 4.141 3.50591 4.33333 3.50591C4.52566 3.50591 4.71011 3.43188 4.84611 3.3001ZM10.8333 4.90264H9.38889C9.19734 4.90264 9.01364 4.97637 8.8782 5.1076C8.74276 5.23884 8.66667 5.41684 8.66667 5.60243C8.66667 5.78803 8.74276 5.96603 8.8782 6.09727C9.01364 6.2285 9.19734 6.30223 9.38889 6.30223H10.8333C11.0249 6.30223 11.2086 6.37596 11.344 6.5072C11.4795 6.63843 11.5556 6.81643 11.5556 7.00203V11.9006C11.5556 12.0862 11.4795 12.2642 11.344 12.3954C11.2086 12.5267 11.0249 12.6004 10.8333 12.6004H2.16667C1.97512 12.6004 1.79142 12.5267 1.65598 12.3954C1.52054 12.2642 1.44444 12.0862 1.44444 11.9006V7.00203C1.44444 6.81643 1.52054 6.63843 1.65598 6.5072C1.79142 6.37596 1.97512 6.30223 2.16667 6.30223H3.61111C3.80266 6.30223 3.98636 6.2285 4.1218 6.09727C4.25724 5.96603 4.33333 5.78803 4.33333 5.60243C4.33333 5.41684 4.25724 5.23884 4.1218 5.1076C3.98636 4.97637 3.80266 4.90264 3.61111 4.90264H2.16667C1.59203 4.90264 1.04093 5.12382 0.634602 5.51753C0.228273 5.91125 0 6.44524 0 7.00203L0 11.9006C0 12.4574 0.228273 12.9914 0.634602 13.3851C1.04093 13.7788 1.59203 14 2.16667 14H10.8333C11.408 14 11.9591 13.7788 12.3654 13.3851C12.7717 12.9914 13 12.4574 13 11.9006V7.00203C13 6.44524 12.7717 5.91125 12.3654 5.51753C11.9591 5.12382 11.408 4.90264 10.8333 4.90264Z" fill="#A4A4A4" />
            </svg>

          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "PDF" && (
        <Tooltip title={title || "PDF"}>
          <StyledWrapper.ActionContainer type="PDF" onClick={onClick}>
            <svg
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.85 3.44L8.57 0.14L8.22 0H0.5L0 0.5V6H1V1H7V4.5L7.5 5H11V6H12V3.8L11.85 3.44V3.44ZM8 4V1L11 4H8ZM0.5 7L0 7.5V13.5L0.5 14H11.5L12 13.5V7.5L11.5 7H0.5ZM11 12V13H1V8H11V12ZM3 11H2.68V12H2V9H3.06C3.81 9 4.19 9.36 4.19 10C4.19194 10.136 4.16433 10.2708 4.10908 10.3951C4.05383 10.5195 3.97226 10.6303 3.87 10.72C3.62218 10.9132 3.31397 11.0124 3 11V11ZM2.94 9.55H2.68V10.48H2.94C3.3 10.48 3.48 10.32 3.48 10.01C3.48 9.7 3.3 9.55 2.94 9.55V9.55ZM7 11.58C7.14769 11.4345 7.26317 11.2597 7.33897 11.0667C7.41476 10.8738 7.44918 10.6671 7.44 10.46C7.44 9.46 6.91 9 5.84 9H4.78V12H5.84C6.05153 12.0102 6.26298 11.9784 6.46211 11.9063C6.66123 11.8342 6.84406 11.7233 7 11.58V11.58ZM5.45 11.45V9.55H5.78C5.90755 9.5419 6.0354 9.55989 6.15576 9.60287C6.27612 9.64586 6.38644 9.71293 6.48 9.8C6.56476 9.88901 6.63061 9.99426 6.67357 10.1094C6.71654 10.2246 6.73573 10.3472 6.73 10.47C6.74498 10.7336 6.65511 10.9924 6.48 11.19C6.38845 11.2776 6.28013 11.3458 6.16156 11.3905C6.04298 11.4352 5.9166 11.4554 5.79 11.45H5.45V11.45ZM9.9 10.84H8.93V12H8.25V9H9.99V9.55H8.93V10.29H9.9V10.84V10.84Z"
                fill="#A6A6A6"
              />
            </svg>
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}
      {type === "Multiple PDF" && (
        <Tooltip title={title || "Multiple PDF"}>
          <StyledWrapper.ActionContainer type="Multiple PDF" onClick={onClick}>
            <PictureAsPdfIcon />
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "Pass" && (
        <Tooltip title="Password">
          <StyledWrapper.ActionContainer type="Pass" onClick={onClick}>
            <LockResetIcon />
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "Time" && (
        <Tooltip title={title || ""}>
          <StyledWrapper.ActionContainer type="Time" onClick={onClick}>
            <AccessTimeFilledIcon sx={{ color: color }} />
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}
      {type === "Phone" && (
        <Tooltip title={title || ""}>
          <StyledWrapper.ActionContainer type="Phone" onClick={onClick} >
            <SystemSecurityUpdateGoodIcon sx={{ color: color }} />
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}
      {type === "Cancel Phone" && (
        <Tooltip title={title || ""}>
          <StyledWrapper.ActionContainer type="Cancel Phone" onClick={onClick} style={{ cursor: "pointer" }}>
            <PhonelinkEraseIcon sx={{ color: color }} />
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}
      {type === "Messages" && (
        <Tooltip title={title || ""}>
          <StyledWrapper.ActionContainer type="Messages" onClick={onClick} style={{ cursor: "pointer" }}>
            <CommentIcon sx={{ color: color }} />
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}

      {type === "Whatsapp" && (
        <Tooltip title={title || "Enviar wathsapp"}>
          <StyledWrapper.ActionContainer type="Whatsapp" onClick={onClick}>
            <WhatsAppIcon sx={{ color: color || "green" }} />
          </StyledWrapper.ActionContainer>
        </Tooltip>
      )}
    </>
  );
}
